<template>
  <div class="footer__contacts">
    <div class="footer__contacts-item">
      {{ company }}.
      {{ address }}
      <!-- Reg.: {{ regNum }} -->
    </div>
    <div class="footer__contacts-item mt-auto">
      Email: <a :href="`mailto:${mailTo}`">{{ mailTo }}</a>
    </div>
    <div class="footer__contacts-item">
      Telephone: <a :href="`tel:${phone.split(' ').join('')}`">{{ phone }}</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      company: import.meta.env.VITE_COMPANY,
      address: import.meta.env.VITE_ADDRESS,
      country: import.meta.env.VITE_COUNTRY,
      regNum: import.meta.env.VITE_REG_NUM,
      phone: import.meta.env.VITE_PHONE,
      mailTo: import.meta.env.VITE_MAILTO,
    };
  },
};
</script>
